import { ICourse } from 'data/entities/course.entity';
import { courseRepository } from 'data/repositories/course.repository';

export const getCourseByIdOrSlug = async (idOrSlug: string): Promise<ICourse | null> => {
    try {
        const course = await courseRepository.getCourseByIdOrSlug(idOrSlug);
        if (!course) throw Error('Course not found!');

        return course;
    } catch ({ message }) {
        return null;
    }
};
